// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getKemasan, insertKemasan, kemasanSelector, updateKemasan,} from "./kemasanSlice";

import {Colors} from "../../../assets/Colors";

const KemasanPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const kemasan = useSelector(kemasanSelector);

    useEffect(() => {
        dispatch(
            getKemasan({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && kemasan.isGetSuccess && !kemasan.isGetFetching) {
            let calc = kemasan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kemasan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (
            search === "" &&
            kemasan.isGetSuccess &&
            !kemasan.isGetFetching
        ) {
            let calc = kemasan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kemasan.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !kemasan?.isGetFetching &&
            kemasan.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = kemasan?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = kemasan.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getKemasan({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (kemasan.isGetSuccess) {
                alertService.success(kemasan.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getKemasan({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (kemasan.isUpdateSuccess) {
                alertService.success(kemasan.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateKemasan({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetKemasan(params) {
    //   return dispatch(getKemasan(params));
    // }

    function handleInsertKemasan(param) {
        setInsertFetch(true);
        const params = {
            NamaKemasan: param.inputOneValue,
            CategoryID: param.dropDownKemasanValue,

        };

        dispatch(insertKemasan(params));
    }

    function handleUpdateKemasan(param) {
        setUpdateFetch(true);

        const params = {
            NamaKemasan: param.inputOneValue,
            KemasanID: currentData.KemasanID,
            status: param.status,
            CategoryID: param.dropDownKemasanValue,

        };
        dispatch(updateKemasan(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getKemasan(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getKemasan(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = kemasan.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? kemasan.count : newCount,
            search: search,
        };
        dispatch(getKemasan(params));

        setPage(1);
        setCount(newCount === "-1" ? kemasan.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Kemasan"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Kemasan"
                                tableData={kemasan.data}
                                colOneTitle="ID"
                                colOneData="KemasanID"
                                colTwoTitle="Nama Kemasan"
                                colTwoData="NamaKemasan"
                                colThreeTitle="Kelompok"
                                colThreeData="CategoryName"
                                status="Status"
                                fetching={kemasan.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        dropDownKemasan={true}
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Kemasan"
                        inputOneTitle="Nama Kemasan"
                        inputOneValue=""
                        submitButtonTitle="Submit"
                        dropDownKemasanValue=""

                        handleSubmit={handleInsertKemasan}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        dropDownKemasan={true}
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.KemasanID}
                        modal={handleModal}
                        modalTitle="Ubah Kemasan"
                        inputOneTitle="Nama Kemasan"
                        inputOneValue={currentData.NamaKemasan}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        dropDownKemasanValue={currentData.CategoryID}
                        handleSubmit={handleUpdateKemasan}
                    />
                )}
            </div>
        );
    }
};

export default KemasanPage;
